export const OPEN_SUBMENU = 'OPEN_SUBMENU';
export const ADD_TO_CART = 'ADD_TO_CART';
export const DELETE_CART = 'DELETE_CART';
export const EMPTY_CART = 'EMPTY_CART';
